import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    restrictedFolder: string;
    contextMenuLabel: string;
    versionPrefixLabel: string;
    formattedDate: (displayDate: Date) => string;
    itemCountLabel: ({ count }: {
        count: number;
    }) => string;
    commentCountLabel: ({ count }: {
        count: number;
    }) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for restricted/private folder */
            restrictedFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetListItem.restrictedFolder?c=2040q0lzspljt", defaultMessage: "Restricted Folder" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for asset context menu button */
            contextMenuLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetListItem.contextMenuLabel?c=bg9ecfk5rjhp", defaultMessage: "Asset context menu" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Prefix label for version number (e.g., "V1") */
            versionPrefixLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetListItem.versionPrefixLabel?c=1wivil9uz1glq", defaultMessage: "V" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Formatted display date for asset (e.g., "Jan 26, 2026") */
            formattedDate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (displayDate: Date): string => __intl__.intl().formatMessage({ id: "AssetListItem.formattedDate?c=3k644jhwhoy6v", defaultMessage: "{displayDate, date, medium}" }, { displayDate: displayDate }));
                },
                enumerable: true,
                configurable: true
            },
            /** Folder item count display with pluralization */
            itemCountLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }): string => __intl__.intl().formatMessage({ id: "AssetListItem.itemCountLabel?c=2kb4pieitnsjm", defaultMessage: "{count, plural, one {1 item} other {{count} items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the comment count indicator (e.g. "5 comments"). */
            commentCountLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }): string => __intl__.intl().formatMessage({ id: "AssetListItem.commentCountLabel?c=9w6ib6tjh6dc", defaultMessage: "{count, plural, one {1 comment} other {{count} comments}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
